// extracted by mini-css-extract-plugin
module.exports = {"information":"infoWarning_information__JKNp9","hintIcon":"infoWarning_hintIcon__1WuFm","tableText":"infoWarning_tableText__3xVDw"};